import React, { Component } from "react";
import { MaintenanceContext } from "context/maintenanceProvider";
import {
  Button,
  Form,
  Icon,
  Pagination,
  Select,
  Table,
} from "semantic-ui-react";
import LetterLoading from "components/loading/letterLoading";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/maintenancePending/pendingList.scss";
import Swal from "sweetalert2";

export default class PendingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      repairList: [],
      searchUid: "",
      begin: 0,
      end: 10,
      pageSize: 10,
      activePage: 1,
    };
  }

  startLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });

  async componentDidMount() {
    const data = {
      state: ["processing"],
      pic: null,
      uid: null,
    };
    this.startLoading();
    await this.setDeviceData(data);
    this.stopLoading();
  }

  setDeviceData = async (data) => {
    await this.context.getMaintenance(data);

    this.setState({
      repairList: this.context.maintenanceList.slice(
        this.state.begin,
        this.state.end
      ),
    });
  };

  confirmAction = (message) => {
    return new Promise((resolve) => {
      const result = window.confirm(message);
      resolve(result);
    });
  };

  deletePending = async (documentNo) => {
    const { deleteMaintenance } = this.context;
    const data = {
      documentNo: documentNo,
    };

    // แสดงข้อความยืนยันการลบ
    const confirmDelete = await this.confirmAction("คุณต้องการลบข้อมูลเอกสารเลขที่ " + documentNo + " ใช่หรือไม่?");
    if (!confirmDelete) {
      return; // ไม่ทำอะไรเมื่อผู้ใช้ยกเลิกการลบ
    }

    const formData = new FormData()
    formData.append("data", JSON.stringify(data));
    // statusForm = "delete";
    console.log("datadelete", data);
    
    let result = await deleteMaintenance(data);
    if (result?.result === "success") {  
      return this.alertDialog("สำเร็จ!", "ลบข้อมูลสำเร็จ", "success");   
    } else {
      return this.alertDialog("ผิดพลาด!", "ลบข้อมูลไม่สำเร็จ", "warning");
    } 
  };

  alertDialog = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    }).then((res) => {
      if(res.isConfirmed && icon === "success" ) {     
      }
    });
  };

  createSearchMaintenance = () => {
    const { searchUid } = this.state;
    const { maintenanceList } = this.context;

    const userOptions = maintenanceList?.map((user) => ({
      key: user.id,
      value: user.userId,
      text: user.userId,
    }));

    return (
      <div className="search">
        <Form>
          <b>ชื่อผู้ใช้งาน</b>
          <Form.Group inline>
            <Form.Field
              control={Select}
              options={userOptions}
              value={searchUid}
              placeholder="ชื่อผู้ใช้งาน"
              search
              onChange={(e, { value }) => this.setState({ searchUid: value })}
            />
            <Button
              onClick={() => {
                this.setDeviceData({
                  state: ["processing"],
                  pic: null,
                  uid: null,
                });
                this.setState({
                  searchUid: "",
                  searchState: "",
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              รีเซต
            </Button>
            <Button
              color="blue"
              onClick={() => {
                this.setDeviceData({
                  state: ["processing"],
                  pic: null,
                  uid: this.state.searchUid,
                });
                this.setState({
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              ค้นหา
            </Button>
          </Form.Group>
        </Form>
      </div>
    );
  };

  maintenanceTable = () => {
    const { repairList } = this.state;
    return (
      <Table celled striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Runing Number</Table.HeaderCell>
            <Table.HeaderCell>วันที่และเวลา</Table.HeaderCell>
            <Table.HeaderCell>ชื่อผู้ใช้งาน</Table.HeaderCell>
            <Table.HeaderCell>ชื่อผู้รับผิดชอบ</Table.HeaderCell>
            <Table.HeaderCell>สถานะแจ้งซ่อม</Table.HeaderCell>
            <Table.HeaderCell>แสดงสถานะ</Table.HeaderCell>
            <Table.HeaderCell>ลบข้อมูล</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {repairList?.map((order) => (
            <Table.Row key={order.id}>
              <Table.Cell>{order.documentNo}</Table.Cell>
              <Table.Cell>{order.createAt}</Table.Cell>
              <Table.Cell>{order?.fullName || order?.userId}</Table.Cell>
              <Table.Cell>
                {order?.ownerEngineerList?.map((name, idx) => (
                  <span key={idx}>
                    {name.name}{" "}
                    {idx + 1 !== order?.ownerEngineerList?.length && "/ "}
                  </span>
                ))}
              </Table.Cell>
              <Table.Cell>
                {order.isReturn === 0 ? "ปกติ" : "Rejected"}
              </Table.Cell>
              <Table.Cell>
                <Button href={`/pending/${order.documentNo}`} color="red">
                  {/* <Icon name="pencil" /> */}
                  รอดำเนินการซ่อม
                </Button>
              </Table.Cell>
              <Table.Cell>
                <Button  
                  className="action-btn"
                  style={{
                    fontFamily: "Kanit",
                    fontSize: "16px",
                    backgroundColor: "#ff6347",
                  }} 
                    onClick={() => this.deletePending(order?.documentNo)}>      
                  ลบข้อมูล
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  };

  paginationUpdate = (e, data) => {
    const { maintenanceList } = this.context;
    const { pageSize } = this.state;

    let beginIdx = (data.activePage - 1) * pageSize;
    let endIdx = data.activePage * pageSize;

    this.setState({ activePage: data.activePage });
    this.setState({
      repairList: [...maintenanceList.slice(beginIdx, endIdx)],
    });
  };

  render() {
    const { isLoading, activePage, pageSize } = this.state;

    return (
      <div className="pendingList">
        <LetterLoading isOpen={isLoading} />
        <Sidebar tabActive="pending" />
        <Navigation />

        <div className="pendingList-content">
          <h2>รอดำเนินการซ่อม</h2>
          <hr />

          <div className="pendingList-content-search">
            {this.createSearchMaintenance()}
          </div>

          <div className="pendingList-content-maintenance">
            {this.maintenanceTable()}
          </div>

          <div className="pendingList-content-pagination">
            <Pagination
              activePage={activePage}
              totalPages={Math.ceil(
                this.context.maintenanceList.length / pageSize
              )}
              onPageChange={this.paginationUpdate}
            />
          </div>
        </div>
      </div>
    );
  }
}

PendingList.contextType = MaintenanceContext;
